module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._t("default", [_vm._l((_vm.items), function(item) {
    return [_c('ObjectViewer', {
      attrs: {
        "item": item
      }
    })]
  })], {
    "items": _vm.items,
    "teams": _vm.teamNames
  }), _vm._v(" "), (_vm.status == 'loading') ? [_vm._t("loader", [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-progress-circular', {
    staticClass: "grey--text",
    attrs: {
      "indeterminate": ""
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.moreItemsAvailable) ? [_vm._t("more", [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.itemLimit += _vm.limit
      }
    }
  }, [_vm._v("Load More...")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.status == 'loaded' && _vm.items.length == 0) ? [_vm._t("empty", [_c('div', {
    staticClass: "pa-3",
    staticStyle: {
      "text-align": "center",
      "font-size": "20px",
      "color": "rgba(68,68,68,0.2)"
    }
  }, [_vm._v("\n                No Data\n            ")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d10a83c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DataLoader.vue
// module id = 2569
// module chunks = 1